import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import ContentContainer from '../../../Content/ContentContainer';
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as DTOS from "../../../../FeralScan.dtos";
import { LocalForm, Control } from 'react-redux-form';
import { PlotSortBy, sortPlots } from '../../../../helpers/graphHelper';
import PaginatedTable, { ISortOption } from '../../../Data/PaginatedTable/PaginatedTable';
import moment = require('moment');
import PlotBadgeContainer from '../../../Data/Plot/PlotBadgeContainer';
import { Link } from 'react-router-dom';
import * as queryString from 'query-string';
import withSortByQuery from '../../../Data/PaginatedTable/withSortByQuery';

type PageAdminPlotsProps = {
}

type PageAdminPlotsActions = {
}

type PageAdminPlotsRouteParams = {
}

type PageAdminPlotsQueryParams = {
    search: string;
}

type PageAdminPlotsPropsMapped = {
    plots: DTOS.Plot[];
    plotsLoading: boolean;
}

type PageAdminPlotsActionsMapped = {
    searchPlots: typeof AdminActionCreators.searchPlotsRequest;
}

type PageAdminPlotsAllPropsInherited = PageAdminPlotsProps & PageAdminPlotsActions;
type PageAdminPlotsAllPropsMapped = PageAdminPlotsPropsMapped & PageAdminPlotsActionsMapped;

type PageAdminPlotsAllProps = IBasePageProps<PageAdminPlotsRouteParams, PageAdminPlotsQueryParams> & Partial<PageAdminPlotsAllPropsMapped> & PageAdminPlotsAllPropsInherited;

class PageAdminPlots extends React.Component<PageAdminPlotsAllProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.props.searchPlots(this.props.queryParams.search, undefined);
    }

    componentDidUpdate(prevProps: PageAdminPlotsAllProps) {
        if (prevProps.queryParams.search != this.props.queryParams.search) {
            this.props.searchPlots(this.props.queryParams.search, false);
        }
    }

    updateQuery(search: { searchText: string }) {
        var currentQueryString = queryString.parse(this.props.location.search);

        currentQueryString.search = search.searchText !== '' ? search.searchText : undefined;

        const newQueryString = queryString.stringify(currentQueryString);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: '?' + newQueryString
        });
    }

    render() {

        const plotSearchForm = <LocalForm
            model="search"
            onSubmit={search =>
                this.updateQuery(search)
            }
            validateOn="submit"
            className="form form-inline col-12 my-2"
        >
            <div className="input-group w-xl-30 w-100">
                <Control.text
                    defaultValue={this.props.queryParams.search}
                    model=".searchText"
                    id="searchText"
                    placeholder=""
                    className="form-control"
                    maxLength={100}
                />
                <div className="input-group-append">
                    <button className="btn btn-primary">Search</button>
                </div>
            </div>
        </LocalForm>;


        const SortPlotsChoices: ISortOption[] = [
            { value: PlotSortBy.ID, label: 'ID' },
            { value: PlotSortBy.APCCODE_CREATEDDATE, label: 'APC Code / Reg. Date' },
            { value: PlotSortBy.APCCODE, label: 'APC Code' },
            { value: PlotSortBy.WATERBODY, label: 'Water Body' },
            { value: PlotSortBy.NEARESTSUBURB, label: 'Town/Suburb' },
            { value: PlotSortBy.NAME, label: 'Site Name' },
            { value: PlotSortBy.CREATEDDATE, label: 'Reg. Date' },
            { value: PlotSortBy.STATUS, label: 'Status' },
        ]

        const PlotsTable = withSortByQuery(PaginatedTable);

        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            {plotSearchForm}
            <hr className="w-100" />
            <div className="col-12">
                <PlotsTable
                    countPerPage={25}
                    data={this.props.plots}
                    dataColumns={[
                        { label: "ID", dataKey: "id" },
                        {
                            label: "APC Code",
                            dataKey: "apcCode",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        {
                            label: "Water Body",
                            dataKey: "waterBody",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        {
                            label: "Town/Suburb",
                            dataKey: "nearestSuburb",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        { label: "Site Name", dataKey: "name" },
                        {
                            label: "Reg. Date",
                            dataKey: undefined,
                            render: (p) => moment(p.createdDate).format(this.props.defaultDateFormat),
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        {
                            label: "Type",
                            dataKey: undefined,
                            render: (p) => p.private ? <span>Private</span> : <span>Public</span>,
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell", 
                        },
                        {
                            label: "Status",
                            dataKey: undefined,
                            render: (p) => <PlotBadgeContainer currentPlot={p} />
                        },
                        {
                            label: "Edit",
                            dataKey: undefined,
                            render: (p) => <Link className="text-nowrap" to={`/admin/site/${p.id}`}><i className="btn-primary fa fa-edit p-2"></i></Link>
                        },
                    ]}
                    dataLoading={this.props.plotsLoading}
                    dataSortOptions={SortPlotsChoices}
                    sort={sortPlots}
                    tableClassName={"table-sm table-bordered table-hover"}
                />
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminPlotsAllProps): PageAdminPlotsPropsMapped => {

    return {
        plots: state.admin.plots,
        plotsLoading: state.admin.plotsLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminPlotsActionsMapped>({
        searchPlots: AdminActionCreators.searchPlotsRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminPlots);